export default "/assets/markers/delivered_off.png"